import React, { useEffect, useRef, useState } from "react";
import './DiscoverRooms.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { animate } from "@motionone/dom";
// import { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; 




export default function DiscoverRooms() {
  const rooms = [
  {
    id: 'Swimming Pool',
    title: 'Swimming Pool',
    desc: 'A refreshing, man-made oasis for recreation, relaxation, and exercise',
    // size: '20 m²',
    img: 'Updated-R2-2nd%20Stage%20Submission%20-%20Anandam%20Township,%20Barsana,%20Mathura-%203D%20views%20at%208K%20Resolution%20(29).jpg',
    alt: 'Swimming Pool'
  },
  {
    id: 'Kids Play Area',
    title: 'Kids Play Area',
    desc: ' A designated, safe zone filled with equipment and toys designed to spark childrens imagination and physical activity',
    // size: '15 m²',
    img: 'kidspalyarea.png',
    alt: 'Kids Play Area'
  },
  {
    id: 'Pool Deck',
    title: 'Pool Deck',
    desc: ' The surrounding paved area of a swimming pool, serving as a safe, non-slip border for sunbathing and access.',
    // size: '15 m²',
    img: 'Updated-R2-2nd%20Stage%20Submission%20-%20Anandam%20Township,%20Barsana,%20Mathura-%203D%20views%20at%208K%20Resolution%20(30).jpg',
    alt: 'Pool Deck'
  },
  {
    id: 'Open Air Theatre',
    title: 'Open Air Theatre',
    desc: ' An outdoor performance venue with tiered seating where entertainment, like plays or concerts, is enjoyed under the sky',
    // size: '16 m²',
    img: 'Anandam%20township,%20Barsana-1st%20Phase-8K%20Renders%20(21).jpg',
    alt: 'Open Air Theatre'
  },
  {
    id: 'Interactive Water Feature',
    title: 'Interactive Water Feature',
    desc: '  A decorative and playful installation that sprays, jets, or pours water, allowing visitors, often children, to directly engage and cool off.',
    // size: '6 m²',
    img: 'Updated-R2-2nd%20Stage%20Submission%20-%20Anandam%20Township,%20Barsana,%20Mathura-%203D%20views%20at%208K%20Resolution%20(33).jpg',
    alt: 'Interactive Water Feature'
  },
  {
    id: 'Temple',
    title: 'Temple',
    desc: ' A designated place of worship and a spiritual, cultural, and community hub integrated directly within the township  planning',
    // size: '6 m²',
    img: 'OAT+TEMPLE_2.jpg',
    alt: 'Temple'
  },
  {
    id: 'Basket Ball Court',
    title: 'Basket Ball Court',
    desc: 'A paved or indoor rectangular playing surface marked with free-throw lines and baskets for playing the game of basketball.',
    // size: '6 m²',
    img: 'Updated-R2-2nd%20Stage%20Submission%20-%20Anandam%20Township,%20Barsana,%20Mathura-%203D%20views%20at%208K%20Resolution%20(28).jpg',
    alt: 'Basket Ball Court'
  },
  {
    id: 'Refloxogy Path',
    title: 'Refloxogy Path',
    desc: ' A specially designed textured walkway that uses varied surface materials to stimulate reflex points on the soles of the feet for health and relaxation.',
    // size: '6 m²',
    img: 'refloxogy.png',
    alt: 'Refloxogy Path'
  },
  {
    id: 'Water Fountain ',
    title: 'Water Fountain',
    desc: 'A decorative structure that jets or streams water into a basin, offering a soothing sight and sound for aesthetic appeal.',
    // size: '6 m²',
    img: 'Updated-R2-2nd%20Stage%20Submission%20-%20Anandam%20Township,%20Barsana,%20Mathura-%203D%20views%20at%208K%20Resolution%20(20).jpg',
    alt: 'Water Fountain'
  },
];

  const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
 const [active, setActive] = useState(rooms[0].id);
  const contentRef = useRef(null);


 
   const sectionRef = useRef(null);
    const [inView, setInView] = useState(false)
  
    useEffect(() => {
      AOS.init({
        duration: 1000, // animation duration
        once: false,     // animation only once on scroll
        
      });
    }, []);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setInView(true);
          }
        },
        { threshold: 0.3 }
      );
  
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
       
  
      return () => {
        if (sectionRef.current) {
          observer.unobserve(sectionRef.current);
        }
      };
    }, []);
  useEffect(() => {
    if (contentRef.current) {
      animate(contentRef.current, { opacity: [0, 1], y: [20, 0] }, {
        duration: 0.5,
        easing: "ease-out"
      });
    }
  }, [active]);
  

  return (
    <section id="discover-rooms">
      <div className="text-center mb-3">
        <button className="btn btn-sm mb-2 details-btn">Exploring Amenities</button>
        <h2 className="section-title">Discover Aanandam Valley</h2>
      </div>

      {/* Tab Nav */}
      <div className="de-tab text-center mb-5" data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">
        <ul className="nav nav-pills justify-content-center" role="tablist">
          {rooms.map(room => (
            <li className="nav-item" key={room.id}>
              <button
                className={`nav-link ${active === room.id ? 'active' : ''}`}
                onClick={() => setActive(room.id)}
                type="button"
              >
                {room.title}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Tab Panels */}
      <div className="container">
        {rooms.map(room => (
         <div 
  key={room.id}
  ref={active === room.id ? contentRef : null}
  className={`tab-pane ${active === room.id ? 'show active' : 'fade'}`}
>

            <div className="row  my-rgt" >
              <div className="col-lg-4 my-color" >
                <div className="relative  rounded-1 ">
            
                  <h3 className="fs-32 mb-4 ">{room.title}</h3>
                  <img data-aos="fade-up"
     
  ref={(el) => {
    if (active === room.id && el) {
      animate(el, { scale: [0.95, 1], opacity: [0, 1] }, {
        duration: 0.4,
        easing: "ease-out",
        delay: 0.1
      });
    }
  }}
  src={`${IMAGE_BASE_URL}/${room.img}`}
  className="img-fluid  magei"
  alt={room.alt}
  style={{ height: "auto", width: "100%", borderRadius: "14px" }} 
/>

                  <div className="my-colorabs mt-3">
                    <p >{room.desc}</p>
                  </div>

                </div>
              </div>
              <div className="col-lg-7" data-aos="fade-up"
     data-aos-duration="3000">
                <div className="relative hidi">
                  <div className="bg-blur abs bottom-0 m-4 px-4 py-2 rounded-2 text-white">
                    <h4 className="blurie">{room.size}</h4>
                  </div>
                  <img  src={`${IMAGE_BASE_URL}/${room.img}`}
 className="img-fluid  imagei" alt={room.alt} style={{
                    width: "100%",
                    borderRadius:"14px"
                  }}/>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}